import { render, staticRenderFns } from "./pdaw-gav.vue?vue&type=template&id=1e88e5a3&"
import script from "./pdaw-gav.ts?vue&type=script&lang=ts&"
export * from "./pdaw-gav.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/bjerre/workspace/pom-dependency-analyzer-web-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSheet } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTreeview } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VSheet,VToolbar,VToolbarTitle,VTreeview})
